import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import { formatAmount } from '@Utils/formatters';
import {
    VIEW_MODE,
    EDIT_MODE,
    STATUS_MAP,
    STATUS_SAVED,
} from '@Utils/constants';
import { erfActions } from '..';

const initialTitle = 'Employee Request Form';

const initialDetailForm = {
    requestorID: 0,
    employeeName: '',
    UserId: '',
    requestDate: moment().format('MM/DD/YYYY'),
    hireNeededDate: moment().format('MM/DD/YYYY'),
    departmentID: 0,
    purposeofRequest: '',
    hiringManagerID: 0,
    additional: '',
    erfStatusID: 0,
    erfTrackerStatusID: 0,
    reasonofRequest: '',
    reasonofRequestCharCount: 250,
    jobTitleID: 0,
    jobLevelID: 0,
    jobPostingStatus: '',
    projectID: 0,
    projectLeaderID: 0,
    headCountno: 0,
    basicRequirements: '',
    basicRequirementsCharCount: 250,
    skillsNeeded: '',
    skillsNeededCharCount: 250,
    specialEquipment: '',
    EquipmentRequestID: 0,
    erfID: undefined,
    equipmentType: '',
    EquipmentArrayIDS: [],
    listOfEquipment: [],
    HiredCandidates: [],
    hiredCandidatesId: [],
    approverID: undefined,
    remarks: '',
    auditTrail: [],
}

const defaultState = {
    title: 'Employee Request Form',
    mode: VIEW_MODE,
    loading: true,
    hasLoadedData: false,
    isEditable: false,
    detailForm: { ...initialDetailForm },
    candidateList: [], 
    loanLedger: {
        show: false,
        list: [],
    },
    alert: {
        show: false,
        title: 'Update success',
        content: 'Successfuly updated record.',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
        onHide: () => { },
    },
    confirmModal: {
        show: false,
        title: 'Confirm Cancellation',
        message: 'Do you want to cancel this PAF?',
        confirmData: null, // Set the data to be passed in confirm
        onConfirm: () => { },
        onClose: () => { },
    },
    userPosition: 'Initial',
};


export default function detailReducer(state = defaultState, action) {
    switch (action.type) {
        case types.UPD_AMOUNT:
        case types.CHG_DETAIL_DATA:
            return update(state, {
                detailForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.UPD_DETAIL_TITLE:
            return update(state, {
                title: { $set: action.payload }
            });
        case types.UPD_DETAIL_MODE:
            return update(state, {
                mode: { $set: action.payload }
            });
        case types.HAS_DETAIL_LOADED:
            return update(state, {
                hasLoadedData: { $set: action.payload }
            });
        case types.SET_HIRED_CANDIDATES:
            return update(state, {
                candidateList: { $set: action.payload.data }
            });
        case types.UPD_SELECTED_HIRED_CANDIDATES:
            return update(state, {
                detailForm: {
                    HiredCandidates: { $set: action.payload.HiredCandidates },
                    hiredCandidatesId: { $set: action.payload.hiredCandidatesId }
                }
            });
        case types.SET_DETAIL_DATA:
            let data = action.payload;
            let editable = false;
            let initialMode = VIEW_MODE;
            if (STATUS_MAP[data.approval] === STATUS_SAVED) {
                editable = true;
                initialMode = EDIT_MODE;
            }
            data.reasonofRequestCharCount = 250 - data.reasonofRequest.length;
            return update(state, {
                title: { $set: initialTitle },
                isEditable: { $set: editable },
                detailForm: { $set: data },
                alert: { $set: defaultState.alert }
            });
        case types.UPD_DETAIL_MEMO_CHAR_COUNT: {
            return update(state, {
                detailForm: {
                    memoCharCount: { $set: state.detailForm.memoCharCount - 1 }
                }
            });
        }
        case types.RESET_ADD_DATA:
            return update(state, {
                detailForm: { $set: {...initialDetailForm , requestorID: action.payload}}
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.HIDE_DETAIL_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SET_DETAIL_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.SET_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: { $set: action.payload }
            });
        case types.HIDE_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: false }
                }
            });
        case types.SHOW_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: true }
                }
            });
        case types.UPDATE_USER_POSITION: 
        return update(state, {
            userPosition: { $set: action.payload }
            });
        case types.IS_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            });
        default:
            return state;
    }
}
